import {
  Box,
  Flex, Spinner, Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { When } from 'react-if';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { StudyListPreviewImage } from 'api/Models';

const NUMBER_OF_IMAGES = 2;

export default function ImagesPreview({ images, imageCount }: { images?: StudyListPreviewImage[], imageCount?: number }): JSX.Element {
  const [loaded, setLoaded] = useState<{ [key: number]: boolean }>({});
  if (!images) return <></>;

  const leftAmountOfImages = imageCount && imageCount > NUMBER_OF_IMAGES ? `+ ${imageCount - NUMBER_OF_IMAGES}` : '';
  const handleImageLoad = (id: number): void => {
    setLoaded((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <Flex height='80px' gap='10px'>
      {images.map((image) => (
        <Flex key={image.id} height='80px' alignItems='center' position='relative'>
          <LazyLoadImage
            src={`/api/thumbnail/${image.id}.png?h=80`}
            height='80px'
            onLoad={() => handleImageLoad(image.id)}
            style={{ borderRadius: '2px' }}
          />

          <When condition={!loaded[image.id]}>
            <Box width='65px'>
              <Spinner />
            </Box>
          </When>
        </Flex>
      ))}
      <Text fontSize='lg' display='flex' alignItems='center'>{leftAmountOfImages}</Text>
    </Flex>
  );
}
